.compare {
  --cols: minmax(0, 1fr) 4.4rem 8.5rem 4.6rem;
  container-type: inline-size;
}

.head {
  display: grid;
  grid-template-columns: var(--cols);
  gap: var(--space-2);
  padding: 0 0 var(--space-2);
  border-bottom: 1px solid var(--ink);
}

.head > :not(:first-child) {
  text-align: right;
}

.item {
  border-bottom: 1px solid var(--rule);
  animation: enter var(--duration-slow) var(--ease-out) both;
  animation-delay: calc(var(--i) * var(--stagger));
}

@keyframes enter {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
}

.row {
  display: grid;
  grid-template-columns: var(--cols);
  gap: 6px var(--space-2);
  align-items: baseline;
  width: calc(100% + var(--space-4));
  margin: 0 calc(var(--space-2) * -1);
  padding: var(--space-3) var(--space-2);
  border: 0;
  background: none;
  text-align: left;
  transition:
    background-color var(--duration-fast) var(--ease-out),
    color var(--duration-fast) var(--ease-out);
}

.row:hover {
  background: var(--surface-sunken);
}

.selected,
.selected:hover {
  background: var(--ink);
  color: var(--surface);
}

.name {
  display: flex;
  gap: var(--space-2);
  align-items: baseline;
  min-width: 0;
}

.id {
  display: inline-grid;
  place-items: center;
  width: 18px;
  height: 18px;
  flex: none;
  border: 1px solid currentColor;
  font: 700 var(--text-sm) / 1 var(--font-mono);
}

.roads {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font: 600 var(--text-lg) / 1.15 var(--font-display);
}

.num {
  text-align: right;
  white-space: nowrap;
  font: 500 var(--text-md) / 1 var(--font-mono);
  font-variant-numeric: tabular-nums;
}

.num small {
  font-size: var(--text-xs);
}
.risk {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
}

/* Qué es el peligro, pegado al nivel: «Alto» solo no se entiende. */
.cause {
  display: inline-flex;
  align-items: flex-start;
  gap: 4px;
  font: 600 var(--text-sm) / 1.15 var(--font-display);
  text-align: right;
}

.cause > svg {
  flex: none;
  margin-top: 1px;
}

.sub {
  grid-column: 1 / -1;
  font-size: var(--text-sm);
  color: var(--ink-muted);
  margin-top: -2px;
}
.profile {
  grid-column: 1 / -1;
  display: block;
  margin-top: 4px;
}

/* Mientras llega la previsión: nada de «Sin datos» falsos; la tira barre la ruta. */
.pending {
  font: 500 var(--text-sm) / 1.2 var(--font-mono);
  color: var(--ink-muted);
}

.selected .pending {
  color: color-mix(in oklch, var(--surface) 75%, transparent);
}

/* Trama que avanza (sin brillos ni degradados); con movimiento reducido queda quieta. */
.scan {
  display: block;
  height: 10px;
  background:
    repeating-linear-gradient(90deg, var(--rule-strong) 0 2px, transparent 2px 8px) 0 0 / 16px 100%,
    var(--surface-sunken);
  animation: scan 0.8s linear infinite;
}

@keyframes scan {
  to {
    background-position:
      16px 0,
      0 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .scan {
    animation: none;
  }
}

/* Al llegar la previsión, el riesgo aparece (no salta). */
.reveal {
  display: block;
  animation: reveal var(--duration-slow) var(--ease-out) both;
  animation-delay: calc(var(--i) * var(--stagger));
}

.risk.reveal {
  display: flex;
}

@keyframes reveal {
  from {
    opacity: 0;
    filter: blur(2px);
  }
}
.worst {
  grid-column: 1 / -1;
  font: 400 var(--text-sm) / 1.4 var(--font-mono);
  color: var(--ink-muted);
}

.selected .sub,
.selected .worst {
  color: color-mix(in oklch, var(--surface) 75%, transparent);
}

.selected .risk :global(svg) {
  color: inherit;
}

/* Estrecho: nombre en su línea y tres lecturas en columnas alineadas con la cabecera. */
@container (max-width: 440px) {
  /* El riesgo (nivel + qué es) se lleva el espacio; tiempo y km son cortos. */
  .head,
  .row {
    grid-template-columns: 5rem minmax(0, 1fr) 4.5rem;
  }

  .head > :first-child {
    display: none;
  }

  .head > :not(:first-child),
  .num {
    text-align: left;
  }

  .risk {
    align-items: flex-start;
  }

  .cause {
    text-align: left;
  }

  .name {
    grid-column: 1 / -1;
    margin-bottom: 2px;
  }
}

.alerts {
  grid-column: 1 / -1;
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  font: 600 var(--text-sm) / 1.2 var(--font-display);
  color: var(--danger);
}

.selected .alerts {
  color: inherit;
}
